import { Component, OnInit, ViewChild  } from '@angular/core';
import { MatTabChangeEvent, MatTabGroup }  from '@angular/material/tabs';
import { Observable } from "rxjs";
import { VinculosPosRecadDTO } from "../../components/pos-recadastramento/aba12-posrecad/vinculosPosRecad.dto";
import { CampanhasService } from "../../service/campanhas/campanhas.service";

@Component({
  selector: 'app-recadastramento-ativos',
  templateUrl: './recadastramento-ativos.component.html',
  styleUrls: ['./recadastramento-ativos.component.sass'],
})
export class RecadastramentoAtivosComponent implements OnInit {
  @ViewChild(MatTabGroup) tabGroup!: MatTabGroup;
  currentTab = 0;
  dadosPessoais: any;
  mostrarAlerta: boolean = false;
  tituloCampanhaRecadVigente: string;

  constructor(private campanhasService: CampanhasService) { }

  ngOnInit(): void {
    this.getTItuloCampanhas();
  }
  mostrarAlertaNoComponente() {
    this.mostrarAlerta = !this.mostrarAlerta
  }

  myTabSelectedTabChange(changeEvent: MatTabChangeEvent) {
    this.currentTab = changeEvent.index;
 }

  avancaParaProximoTab() {
    if (this.currentTab < this.tabGroup._tabs.length - 1) {
      this.currentTab += 1;
      this.tabGroup.selectedIndex = this.currentTab;
    }
  }
  voltarParaAbaAnterior(): void {
    this.currentTab -= 1;
    this.tabGroup.selectedIndex = this.currentTab;

  }

  private getTItuloCampanhas() {
    this.getCampanhaRecadVigente().subscribe( resp => {
      this.tituloCampanhaRecadVigente = resp.nome;
    })
  }

  private getCampanhaRecadVigente(): Observable<any> {
    return this.campanhasService.getCampanhaRecadVigente();
  }
}
